export default function ServicesSection() {
  return (
    <section id="services" className="py-14 md:py-24 bg-gradient-to-br from-amber-50 to-teal-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="mb-10 md:mb-16">
          <p className="text-xs md:text-sm text-gray-500 uppercase tracking-wider mb-1 md:mb-2">Our Business</p>
          <h2 className="text-2xl md:text-5xl font-bold text-slate-800 leading-tight">
            二つの事業で
          </h2>
          <h2 className="text-2xl md:text-5xl font-bold text-slate-800 leading-tight">
            飲食業界を支える
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-8">
          {[
            {
              bg: 'from-teal-50 to-emerald-50',
              icon: 'ri-restaurant-2-line',
              title: '花木流味噌 五反野店',
              text: 'こだわりの味噌スープと厳選食材を使用した、本格味噌ラーメンをご提供します。五反野の地に根ざし、地域の皆様に愛される一杯を追求しています。',
            },
            {
              bg: 'from-amber-50 to-yellow-50',
              icon: 'ri-line-chart-line',
              title: '経営コンサルティング',
              text: '飲食店経営の実践経験を基に、店舗開業から運営改善まで総合的にサポート。収益改善、人材育成、ブランディングなど、あらゆる経営課題に対応します。',
            },
            {
              bg: 'from-rose-50 to-pink-50',
              icon: 'ri-team-line',
              title: 'トータルサポート',
              text: 'メニュー開発、スタッフ研修、マーケティング戦略まで、飲食店経営に必要なすべての要素をワンストップでサポート。長期的なパートナーとして成長を支えます。',
            },
          ].map((item) => (
            <div key={item.title} className={`bg-gradient-to-br ${item.bg} rounded-2xl p-5 md:p-8 hover:shadow-lg transition-all duration-300`}>
              <div className="w-12 h-12 flex items-center justify-center mb-4 md:mb-6">
                <i className={`${item.icon} text-3xl md:text-4xl text-slate-700`}></i>
              </div>
              <h3 className="text-base md:text-2xl font-bold text-slate-800 mb-2 md:mb-4">{item.title}</h3>
              <p className="text-xs md:text-base text-gray-700 leading-relaxed">{item.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
